<script setup lang="ts">
import { ref, watch, toRefs, computed, onMounted } from 'vue';

interface List {
  id: number;
  label: string;
}

// 定义 props 类型
interface Props {
  content?: string;
  offset?: string;
  triangleOffset?: string;
}

// 使用 withDefaults 设置默认值
const props = withDefaults(defineProps<Props>(), {
  content: '',
  offset: '-24px',
  triangleOffset: '24px',
});

const { content } = toRefs(props);

const isShowPopover = ref(false); //是否显示下拉框

const hideComponent = () => {
  isShowPopover.value = false;
};

const mouseenter = () => {
  isShowPopover.value = true;
};

const mouseleave = () => {
  isShowPopover.value = false;
};

onMounted(() => {});
</script>

<template>
  <div
    class="fr-ac pos-r"
    @mouseenter="mouseenter"
    @mouseleave="mouseleave"
    v-click-outside="hideComponent"
  >
    <slot></slot>
    <div class="popover-space" v-if="isShowPopover"></div>
    <div class="popover-box fr-ac" v-if="isShowPopover">
      <slot name="content"></slot>
      {{ content }}
    </div>
  </div>
</template>

<style lang="scss" scoped>
.popover-space {
  position: absolute;
  z-index: 9;
  min-width: 300px;
  height: 100px;
  top: 2px;
  left: -24px;
}

.popover-box {
  position: absolute;
  z-index: 9;
  left: v-bind('offset');
  top: 40px;
  padding: 14px 23px;
  width: max-content;
  border-radius: var(--border-radius);
  // background: linear-gradient(180deg, #111b37 0%, #091023 100%);
  background: var(--bg-color-tooltip);
  font-size: 13px;
  box-shadow: var(--box-shadow);
  backdrop-filter: blur(10px);
}

.popover-box::before {
  content: '';
  position: absolute;
  // left: 24px;
  left: v-bind('triangleOffset');
  top: -8px;
  width: 0;
  height: 0;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  // border-bottom: 8px solid rgba(55, 133, 255, 0.3);
  border-bottom: 8px solid var(--bg-color-tooltip);
}

@media (max-width: 767px) {
  .popover-space {
    min-width: auto;
  }

  .popover-box {
    max-width: calc(100vw - 32px);
  }
}
</style>
